import { defineComponent as _defineComponent } from 'vue'
import { Dialog as ElDialog } from 'element-ui';
import { ref, onMounted, watch, nextTick } from 'vue';
import { sleep } from '@/js/lib/helper/sleep';
import IButton from './IButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'IModal',
  props: {
    value: { type: Boolean, default: true },
    width: { default: '500px' },
    textCancel: { default: 'キャンセル' },
    textOk: { default: 'OK' },
    withActionButton: { type: Boolean },
    withCancelButton: { type: Boolean, default: true },
    closeOnCancel: { type: Boolean, default: true },
    closeOnOk: { type: Boolean, default: true },
    fadeOut: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["input", "open", "close", "cancel", "ok"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'open'): void;
  (e: 'close'): void;
  (e: 'cancel'): void;
  (e: 'ok', event?: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, width: string, textCancel: string, textOk: string, withActionButton?: boolean, withCancelButton: boolean, closeOnCancel: boolean, closeOnOk: boolean, fadeOut?: boolean, isLoading?: boolean };



const buttonOk = ref();
const isShow = ref(false);
const modalClose = () => {
  isShow.value = false;
};
const onCancel = () => {
  if (props.closeOnCancel) {
    isShow.value = false;
  }
  emit('cancel');
};
const onOk = () => {
  emit('ok');
  if (props.closeOnOk) {
    isShow.value = false;
  }
};

onMounted(async () => {
  isShow.value = props.value;
  if (props.withActionButton) {
    nextTick(() => {
      if (buttonOk.value) {
        buttonOk.value.focus();
      }
    });
  }
  if (props.fadeOut) {
    await sleep(1200);
    isShow.value = false;
  }
});

watch(
  () => props.value,
  () => {
    isShow.value = props.value;
  },
);

watch(isShow, () => {
  if (isShow.value) {
    emit('open');
  } else {
    emit('close');
    emit('input', false);
  }
});

expose({
  modalClose,
});

return { __sfc: true,props, emit, buttonOk, isShow, modalClose, onCancel, onOk, ElDialog, IButton }
}

})